import { DASHBOARD_ROUTES } from '../constants/dashboardRoutes';

/** Bottom-nav tab → route for Essentials mobile dashboard (mirrors Pro /trade mobile tabs). */
export const DASHBOARD_TAB_ROUTES = {
  askAI: DASHBOARD_ROUTES.ai,
  watchlists: DASHBOARD_ROUTES.watchlists,
  market: DASHBOARD_ROUTES.market,
  journal: DASHBOARD_ROUTES.journals,
  trade: DASHBOARD_ROUTES.trade,
  portfolio: DASHBOARD_ROUTES.overview,
  settings: DASHBOARD_ROUTES.settings,
  performance: DASHBOARD_ROUTES.performance,
};

export function getDashboardRouteForTab(page) {
  return DASHBOARD_TAB_ROUTES[page] ?? null;
}

/** Market bottom-nav destination. Overview requires an effective MD source. */
export function getMarketTabRoute(canUseMarketTools) {
  return canUseMarketTools ? DASHBOARD_ROUTES.market : DASHBOARD_ROUTES.marketResearch;
}

/** Paths that render Market Overview, Relative Strength, or desktop Positions Overview. */
export function isBrokerMarketDataDashboardPath(pathname) {
  if (!pathname) return false;
  const path = String(pathname).split('?')[0];
  if (path.includes('/market/positions')) return true;
  if (path.includes('/market/overview')) return true;
  if (path.includes('/market/relative-strength')) return true;
  return path === DASHBOARD_ROUTES.market || path === `${DASHBOARD_ROUTES.market}/`;
}

/** Active bottom-nav tab from pathname, or null for auxiliary routes (settings, research, …). */
export function getDashboardMobileTab(pathname) {
  if (pathname === '/dashboard' || pathname === '/dashboard/') return 'portfolio';
  if (pathname.startsWith('/dashboard/overview')) return 'portfolio';
  if (pathname.startsWith('/dashboard/backtest')) return 'portfolio';
  if (pathname.startsWith('/dashboard/rs-study')) return 'portfolio';
  if (pathname.startsWith('/dashboard/market')) return 'market';
  if (pathname.startsWith('/dashboard/ai-automations')) return null;
  if (pathname.startsWith('/dashboard/ai')) return 'askAI';
  if (pathname.startsWith('/dashboard/watchlists')) return 'watchlists';
  if (pathname.startsWith('/dashboard/journals')) return 'journal';
  if (pathname.startsWith('/dashboard/trade')) return 'trade';
  if (pathname.startsWith('/dashboard/health')) return 'portfolio';
  if (pathname.startsWith('/dashboard/performance')) return 'performance';
  return null;
}

/** Active bottom-nav tab for the shared /trade + /dashboard mobile shell. */
export function getMobileBottomNavActivePage(pathname) {
  if (!pathname) return null;
  if (pathname === '/trade' || pathname.startsWith('/trade/')) return 'trade';
  return getDashboardMobileTab(pathname);
}

/** Deep dashboard routes (not a bottom-nav tab) — show back header on mobile. */
export function isDashboardAuxiliaryRoute(pathname) {
  if (!pathname.startsWith('/dashboard')) return false;
  return getDashboardMobileTab(pathname) === null;
}

/**
 * Default back target for auxiliary dashboard pages.
 * Prefers location.state.from (set by mobile menu deep links).
 */
export function getDashboardBackTarget(pathname, locationState) {
  if (locationState?.from && typeof locationState.from === 'string') {
    return locationState.from;
  }
  if (pathname.startsWith('/dashboard/alerts')) {
    return DASHBOARD_ROUTES.health;
  }
  return DASHBOARD_ROUTES.overview;
}
